import React from "react";
import PropTypes from "prop-types";
import { Box, Grid, Typography } from "@mui/material";
import { FinancingCard, getFinancingHeadingSx } from "../FinancingPresentation";

const CashTable = ({ cashPaymentData, isLincolnBrand = false }) => {
  const filteredData = cashPaymentData;

  return (
    <>
      <Box
        gridColumn={{
          xs: "span 12",
        }}
      >
        <Grid container>
          <Grid item>
            <Typography
              variant="h3"
              sx={getFinancingHeadingSx(isLincolnBrand)}
              data-testid="payment-type-heading"
            >
              Cash
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Box
        gridColumn={{
          xs: "span 12",
        }}
      >
        <FinancingCard data={filteredData} isLincolnBrand={isLincolnBrand} />
      </Box>
    </>
  );
};

CashTable.propTypes = {
  isLincolnBrand: PropTypes.bool,
  cashPaymentData: PropTypes.object.isRequired,
};

export default CashTable;
